import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { getPricingTierById } from '../../utils/api/pricingTier';

function ViewPricingTierModal({ id, show, onClose }) {
  const [pricingTier, setPricingTier] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id || !show) return;

    setLoading(true);
    getPricingTierById(id)
      .then((res) => {
        setPricingTier(res || null);
      })
      .catch((error) => {
        console.error('Error fetching pricing tier:', error);
        setPricingTier(null);
      })
      .finally(() => setLoading(false));
  }, [id, show]);

  if (!show) return null;

  return (
    <motion.div
      className="modal fade show"
      tabIndex="-1"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      style={{
        display: 'block',
        backgroundColor: 'rgba(0,0,0,0.6)',
        backdropFilter: 'blur(4px)',
        zIndex: 1050,
      }}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content" style={{ borderRadius: '16px', border: 'none' }}>
          <div className="modal-header">
            <h6 className="modal-title">Pricing Tier Details</h6>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body">
            {loading ? (
              <div className="text-center flex gap-10">
                {Array.from({ length: 5 }).map((_, i) => (
                  <div
                    key={i}
                    className="shimmer shimmer-text"
                    style={{ width: '120px', height: '2.5rem', margin: 'auto' }}
                  ></div>
                ))}
              </div>
            ) : pricingTier ? (
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label fw-semibold">Label</label>
                  <div className="form-control">{pricingTier.label}</div>
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Rate Per Minute (₹)</label>
                  <div className="form-control">
                    ₹{parseFloat(pricingTier.ratePerMinute).toFixed(2)}
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Minimum Minutes</label>
                  <div className="form-control">{pricingTier.minMinutes}</div>
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Maximum Minutes</label>
                  <div className="form-control">{pricingTier.maxMinutes}</div>
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Status</label>
                  <div className="form-control">
                    <span className={`badge ${pricingTier.isActive ? 'bg-success' : 'bg-danger'}`}>
                      {pricingTier.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Created At</label>
                  <div className="form-control">
                    {new Date(pricingTier.createdAt).toLocaleString('en-IN')}
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Updated At</label>
                  <div className="form-control">
                    {new Date(pricingTier.updatedAt).toLocaleString('en-IN')}
                  </div>
                </div>
              </div>
            ) : (
              <div className="text-danger text-center py-4">
                Pricing Tier not found or failed to load.
              </div>
            )}
          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default ViewPricingTierModal;
